import { SearchQueryPredicate } from "types/generated";

/**
 * Exact, case-sensitive match. Prefer this over makeStringMatchesPredicate whenever the value is
 * known exactly (an ID, a slug, a path) - the backend can serve it from an index instead of a
 * case-insensitive LIKE scan.
 */
export const makeStringEqualsPredicate = (
  field: string,
  values: string[]
): SearchQueryPredicate => ({
  field: field,
  exclude: null,
  constraint: {
    stringEquals: values,
    stringMatches: null,
    booleanEquals: null,
    enumEquals: null,
    hierarchyNodeValueEquals: null,
    hierarchyNode: null,
    timeInLast: null,
    timeInRange: null,
  },
});

export const makeStringMatchesPredicate = (
  field: string,
  values: string[]
): SearchQueryPredicate => ({
  field: field,
  exclude: null,
  constraint: {
    stringEquals: null,
    stringMatches: values,
    booleanEquals: null,
    enumEquals: null,
    hierarchyNodeValueEquals: null,
    hierarchyNode: null,
    timeInLast: null,
    timeInRange: null,
  },
});

export const makeEnumEqualsPredicate = (field: string, values: string[]): SearchQueryPredicate => ({
  field: field,
  exclude: null,
  constraint: {
    stringEquals: null,
    stringMatches: null,
    booleanEquals: null,
    enumEquals: values,
    hierarchyNodeValueEquals: null,
    hierarchyNode: null,
    timeInLast: null,
    timeInRange: null,
  },
});

export const makeTimeInRangePredicate = (
  field: string,
  start: number,
  end: number
): SearchQueryPredicate => ({
  field: field,
  exclude: null,
  constraint: {
    timeInRange: { start, end },
    stringEquals: null,
    stringMatches: null,
    booleanEquals: null,
    enumEquals: null,
    hierarchyNodeValueEquals: null,
    hierarchyNode: null,
    timeInLast: null,
  },
});
